import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import TagTemplate from '@ui/Tag/Tag';
import LecturerTemplate from '@ui/Lecturer/Lecturer';
import { formatLecturerName } from '@utils/person.utils';
import { publicAssets } from '@utils/url.utils';
import moment from 'moment';
import { ROUTES, getImageBaseURL } from '../../constants';
import { IAcademyItem2 } from '../../interfaces/Calendar';
import { ILecturerItem } from '../../interfaces/Lecturer';
import {
    Item,
    Tags,
    Topic,
    TopicDescription,
    TopicFirstRow,
    TopicSecondRow,
    TopicThirdRow,
    TopicTitle,
    TopicPlaces,
    TopicPlace,
    Lecturers
} from './AcademyProduct.elements';

export interface AcademyProductProps {
    event: IAcademyItem2;
}

const AcademyProductTemplate: FC<AcademyProductProps> = ({ event }) => {
    const { t } = useTranslations();

    const router = useRouter();

    const [eventDetail, setEventDetail] = useState({});
    const [myDate, setDate] = useState('');

    useEffect(() => {
         const peopleMap = new Map<string, any>();
         const venuesMap = new Map<string, any>();
         const dateFromSet = new Set<Date>();
         const dateToSet = new Set<Date>();
         let isOnline = false;
 
         event.modules.forEach(item => {
             if (item.date_from) {
                 dateFromSet.add(item.date_from);
             }
 
             if (item.date_to) {
                 dateToSet.add(item.date_to);
             }
 
             item.events.forEach(event => {
                 event.eventDates.forEach(ed => {
 
                     if (!ed.venues?.length) {
                         isOnline = true;
                     }
 
                     ed.people.forEach(person => {
                         peopleMap.set(person._id, person);
                     });
 
                     ed.venues.forEach(venue => {
                         venuesMap.set(venue._id, venue);
                     });
                 });
             });
         });
 
         const result = {
             people: Array.from(peopleMap.values()),
             venues: Array.from(venuesMap.values()),
             date_from: Array.from(dateFromSet),
             date_to: Array.from(dateToSet),
             isOnline,
         };
 
         setEventDetail(result);
 
         const min = result?.date_from?.reduce(function (a, b) { return a < b ? a : b; });
         const max = result?.date_to?.reduce(function (a, b) { return a > b ? a : b; });
 
         let myDate;
         if (
             moment(min).format('D. M. YYYY') === moment(max).format('D. M. YYYY')
         ) {
             myDate = moment(min).format('D. M. YYYY');
             setDate(myDate);
         } else {
             myDate = `${moment(min).format('D. M. YYYY')} - ${moment(max).format('D. M. YYYY')}`;
             setDate(myDate);
         }
 
 
     }, [event]);

    const buildRedirectPathname = () => `${ROUTES.ACADEMY_DETAIL}/${event.academy?.slug}`;

    return (
        <>
        <Item>
            <Topic>
                <TopicFirstRow>
                    {myDate}
                </TopicFirstRow>
                <TopicSecondRow>
                    <TopicTitle onClick={() => router.push(buildRedirectPathname())}>{event?.academy?.title}</TopicTitle>
                    {eventDetail?.venues?.length > 0 && (
                        <TopicPlaces>
                            {eventDetail?.venues?.map((item) => (
                                <TopicPlace key={item}>
                                    {item.name}
                                </TopicPlace>
                            ))}
                        </TopicPlaces>
                    )}

                    {eventDetail?.isOnline && (
                        <TopicPlaces>
                            <TopicPlace>
                                online
                            </TopicPlace>
                        </TopicPlaces>
                    )}
                </TopicSecondRow>
                <>
                    <TopicThirdRow>

                        {<Lecturers>
                            {(eventDetail.people)?.map(
                                (person: ILecturerItem, key: number) => (
                                    <LecturerTemplate
                                        key={`lecturer-${key}`}
                                        image={
                                            person?.photo
                                                ? `${getImageBaseURL()}/media/people/${person?.photo}`
                                                : `${publicAssets('/avatar.svg')}`
                                        }
                                        name={formatLecturerName(person)}
                                        slug={person?.slug}
                                    />
                                )
                            )}
                        </Lecturers>}
                        <ButtonTemplate
                            marginTop={10}
                            onClick={() =>
                                router.push({
                                    pathname: buildRedirectPathname(),
                                })
                            }

                            text={t('homepage.calendar.button.detail')}
                        />
                    </TopicThirdRow>
                </>
            </Topic >
        </Item >
        </>
    );
};

export default AcademyProductTemplate;
